
import { defineComponent } from "vue";

export default defineComponent({
    name: "v-tick",
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
        margin: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
})
